module.exports = __webpack_public_path__ + "img/photoCaseImei.011bcc09.png";